import styled, { css } from 'styled-components';

export const ListItems = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
`;

export const Item = styled.li`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 24px 0;
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
    width: 100%;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
  `}
`;

export const ItemLabel = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      svg{
        position: relative;
        top: 12px;
      }
  `}
`;

export const ItemValue = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowPure};

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      margin-left: 36px;
    }
  `}
`;
